import { __generator } from "tslib";
import { all, put, select } from 'redux-saga/effects';
import { selectors, withOffset } from '../../Stream';
import { DEVIATIONS_PER_FETCH } from '../constants';
import { getSearchQuery } from '../selectors';
import { getBrowseDeviationStreamId } from '../helpers';
function handleInitBrowseDeviationStream() {
    var searchQuery, streamId, isStreamInitialized;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getSearchQuery)];
            case 1:
                searchQuery = _a.sent();
                streamId = getBrowseDeviationStreamId(searchQuery);
                return [4 /*yield*/, select(selectors.isInitialized, streamId)];
            case 2:
                isStreamInitialized = _a.sent();
                if (isStreamInitialized && !searchQuery) {
                    return [2 /*return*/];
                }
                return [4 /*yield*/, all([
                        put(withOffset.actions.initialize({
                            streamId: streamId,
                            itemsPerFetch: DEVIATIONS_PER_FETCH,
                        })),
                        put(withOffset.actions.fetch(streamId)),
                    ])];
            case 3:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export default handleInitBrowseDeviationStream;
//# sourceMappingURL=initBrowseStream.js.map